import { render } from "./DrawInputTable.vue?vue&type=template&id=3be32c6a"
import script from "./DrawInputTable.vue?vue&type=script&lang=js"
export * from "./DrawInputTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__